export function getProductData(featureId, productData) {
	return productData.reduce(
		(feat, component) => {
			const f = component.features.find(
				feature => feature.featureId === featureId
			);
			if (f) {
				return f;
			} else {
				return feat;
			}
		},
		null
	);
}
